const styles = (theme, props) => ({
  root: {
    backgroundColor: theme.colors.eyYellow,
    borderRadius: 0,
    border: '1px solid #2E2E38',
    color: '#000',
    height: 48,
    maxWidth: props.noMaxWidth ? 'none' : 160,
    padding: '0 30px',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #2E2E38',
      backgroundColor: theme.colors.eyYellow,
    },
    '&:disabled': {
      border: '1px solid transparent',
    },
    textTransform: 'none',
  },
  label: {
    color: theme.colors.eyConfidentGrey,
    fontWeight: 'bold',
    fontSize: '1rem',
    whiteSpace: 'nowrap',
  },
  disabled: {
    backgroundColor: theme.colors.eyGrey3,
  },
  labelDisabled: {
    color: theme.colors.eyGrey6,
    fontWeight: 'bold',
    fontSize: '14px',
  },
});

export default styles;
